// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/public.scss
// module id = PWV9
// module chunks = 1